// src/app/services/channels.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ChannelsService {
  private apiUrl = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getChannels(eventCode: string, lat?: number | null, lng?: number | null) {
    const url = `${this.apiUrl}/channels?code=${eventCode}` + this.geoQuery(lat, lng);

    const headers = new HttpHeaders({
      'genlix': '570f31e7-55cb-482e-be09-52dae38a8db3'
    });
    return firstValueFrom(this.http.get<any>(url, { headers })).then(data => {
      // console.log("Fetched data:", data);
      return data; 
    }).catch(err => {
      console.error('HTTP Error:', err.message);
      throw err;
    });
  }

  getChannelByCode(channelCode: string, lat?: number | null, lng?: number | null): Promise<any> {
    const url = `${this.apiUrl}/channel?code=${channelCode}` + this.geoQuery(lat, lng);
    const headers = new HttpHeaders({ 'genlix': '570f31e7-55cb-482e-be09-52dae38a8db3' });
    return firstValueFrom(this.http.get<any>(url, { headers })).catch(err => {
      console.error('HTTP Error:', err.message);
      throw err;
    });
  }

  /** Builds the geofence query suffix (`&lat=..&lng=..`) or an empty string. */
  private geoQuery(lat?: number | null, lng?: number | null): string {
    return (lat != null && lng != null) ? `&lat=${lat}&lng=${lng}` : '';
  }

  createChannel(siteCode: string, newChannel: any): Promise<any> {
    const url = `${this.apiUrl}/sites/${siteCode}/channels`;
    const headers = new HttpHeaders({
      'genlix': '570f31e7-55cb-482e-be09-52dae38a8db3',
      'Content-Type': 'application/json'
    });

    return firstValueFrom(this.http.post<any>(url, newChannel, { headers })).then(data => {
      // console.log("Posted data:", data);
      return data; 
    }).catch(err => {
      console.error('HTTP Error:', err.message);
      throw err;
    });
  }


  updateChannel(channelCode: string, updatedChannel: any): Promise<any> {
    const url = `${this.apiUrl}/channels/${channelCode}`;
    const headers = new HttpHeaders({
      'genlix': '570f31e7-55cb-482e-be09-52dae38a8db3',
      'Content-Type': 'application/json'
    });

    return firstValueFrom(this.http.put<any>(url, updatedChannel, { headers })).then(data => {
      console.log('Updated channel data:', data);
      return data;
    }).catch(err => {
      console.error('HTTP Error:', err.message);
      throw err;
    });
  }

  // Delete a channel
  deleteChannel(channelCode: string): Promise<any> {
    const url = `${this.apiUrl}/channels/${channelCode}`;
    const headers = new HttpHeaders({
      'genlix': '570f31e7-55cb-482e-be09-52dae38a8db3'
    });

    return firstValueFrom(this.http.delete<any>(url, { headers }))
      .then(data => {
        console.log('Deleted channel:', data);
        return data;
      })
      .catch(err => {
        console.error('HTTP Error:', err.message);
        throw err;
      });
  }
}
